export default __webpack_public_path__ + "static/media/mustard-yellow-0-designify.d87c9ab4.png";